import { Actor, type HttpAgent } from '@dfinity/agent';
import { idlFactory } from '../declarations/generator';
import type { _SERVICE } from '../declarations/generator/generator.did';

import { getCanisterId as getConfigCanisterId } from '../config/canisterIds';

// Get canister ID from environment or config
const getCanisterId = (): string => {
  if (import.meta.env.VITE_GENERATOR_CANISTER_ID) {
    return import.meta.env.VITE_GENERATOR_CANISTER_ID;
  }
  // Try config file
  const configId = getConfigCanisterId('generator');
  if (configId) return configId;
  
  // Throw error if not configured
  throw new Error('Generator canister ID not configured. Set VITE_GENERATOR_CANISTER_ID in .env.production');
};

export async function createGeneratorActor(agent: HttpAgent): Promise<_SERVICE> {
  const canisterId = getCanisterId();
  return Actor.createActor(idlFactory, {
    agent,
    canisterId,
  });
}

